import { ButtonComponent } from "@/components";
import { CurrencyConverter, IMAGES, WEB_COLORS } from "@/lib/constants";
import { useTheme } from "@emotion/react";
import {
  Box,
  Divider,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Image from "next/image";

function toNumber(str) {
  return Number(str.replace(/[₹,]/g, ""));
}

const INSURANCE_BENEFITS = [
  {
    icon: IMAGES.filledCalendarInsuranceIcon,
    alt: "calendar icon",
    text: "EMI Cover for Job Loss & Critical Illness*",
  },
  {
    icon: IMAGES.filledCoveredLoanInsuranceIcon,
    alt: "Loan covered icon",
    text: "Loan Covered in Case of Death",
  },
  {
    icon: IMAGES.filledOpdInsuranceIcon,
    alt: "OPD icon",
    text: "Tele consultation & OPD Benefits",
  },
];
const LimitedOfferReminder = ({
  baseEmi,
  amount,
  setInsuranceRequired,
  handleContinueWithInsurance,
  handleContinueWithoutInsurance,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const isBelowMd = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Stack backgroundColor={"#fff"} minWidth={"290px"}>
      <Stack
        bgcolor={"#E5F1F1"}
        p={{ xs: 1, md: 1 }}
        textAlign={"left"}
        borderRadius={{ xs: "8px", md: 4 }}
      >
        <Stack
          flexDirection={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          // spacing={1}
          mb={{ xs: 1, md: 0 }}
        >
          <Stack>
            <Box
              backgroundColor={"#00F200"}
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              alignSelf={"flex-start"}
              px={"8px"}
              py={"4px"}
              mt={{ xs: 0 }}
              borderRadius={"30px"}
              gap={0.5}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <circle cx="12" cy="12" r="9" />
                <path d="M12 7v5h5" />
              </svg>
              <Box
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                // gap={1}
              >
                <Typography
                  fontWeight={{ md: 500, xs: 400 }}
                  fontSize={{ md: "14px", xs: "8px", sm: "10px" }}
                >
                  Limited Offer
                </Typography>
              </Box>
            </Box>

            <Stack>
              <Typography
                fontWeight={{ xs: 400 }}
                fontSize={{ xs: "14px", sm: "16px" }}
                color={"#004135"}
                display={"inline-block"}
              >
                One plan triple protection at{" "}
                <Typography
                  fontWeight={{ xs: 700, md: 500 }}
                  fontSize={{ xs: "14px", sm: "16px" }}
                  color={"#004135"}
                  display={"inline-block"}
                >
                  {CurrencyConverter(amount ?? 0)} per month only
                </Typography>{" "}
              </Typography>
            </Stack>
          </Stack>
          <Stack>
            <Image
              src={IMAGES.protectionShield}
              width={isMobile ? 60 : 70}
              alt="shield"
            />
          </Stack>
        </Stack>

        <Grid
          container
          justifyContent="space-between"
          alignItems="stretch"
          color="#3F3F3F"
          columnSpacing={{ xs: 1, md: 1 }}
        >
          {INSURANCE_BENEFITS.map((item) => (
            <Grid item xs={4} key={item.text}>
              <Stack
                justifyContent="center"
                alignItems="center"
                borderRadius="8px"
                border="1px solid #F0F0F0"
                backgroundColor="#FFFFFF"
                height={{ xs: 130, md: 120 }}
                px={{ xs: 1, md: 1 }}
              >
                <Image
                  src={item.icon}
                  alt={item.alt}
                  width={isBelowMd ? 50 : 60}
                  height={isBelowMd ? 50 : 60}
                />

                <Typography
                  textAlign="center"
                  fontWeight={400}
                  fontSize={{ md: "12px", xs: "11px" }}
                  // lineHeight={{ xs: "15px", md: "18px" }}
                  color="#565656"
                  mt={{ xs: 1, md: 1 }}
                >
                  {item.text}
                </Typography>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Stack>

      <Grid
        container
        width="100%"
        columnSpacing={{ xs: 1, md: 2 }}
        alignItems="stretch"
        sx={{ mt: { xs: 1.5, md: 1 } }}
      >
        <Grid item xs={6} sx={{ display: "flex" }}>
          <Box
            sx={{
              width: "100%",
              // height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: { xs: 0.75, md: 1 },
              p: { xs: 1, md: 1 },
              border: "1px solid #E5E5E5",
              borderRadius: { xs: "12px", md: "16px" },
              backgroundColor: "#FFFFFF",
              // boxSizing: "border-box",
            }}
            textAlign="center"
          >
            <Image
              src={IMAGES.cross}
              alt="cross"
              width={isBelowMd ? 24 : 28}
              height={isBelowMd ? 24 : 28}
            />

            <Typography
              fontWeight={500}
              fontSize={{ xs: "12px", md: "14px" }}
              color="#1E2525"
            >
              EMI without Insurance
            </Typography>

            <Typography
              fontWeight={700}
              fontSize={{ xs: "14px", sm: "18px" }}
              color="#1E2525"
            >
              {CurrencyConverter(
                typeof baseEmi === "string" ? toNumber(baseEmi) : baseEmi,
              )}
              <Typography
                component="span"
                fontWeight={400}
                fontSize={{ xs: "14px", sm: "18px" }}
                color="#1E2525"
                ml={0.25}
              >
                /-
              </Typography>
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={6}>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: { xs: 0.75, md: 1 },
              p: { xs: 1, md: 1 },
              border: "1px solid #00B800",
              borderRadius: { xs: "12px", md: "16px" },
              backgroundColor: "#E9FFE6",
              boxSizing: "border-box",
              boxShadow: "0px 16px 28px rgba(0, 0, 0, 0.12)",
            }}
            textAlign="center"
          >
            <Image
              src={IMAGES.check}
              alt="check"
              width={isBelowMd ? 24 : 28}
              height={isBelowMd ? 24 : 28}
            />

            <Typography
              fontWeight={500}
              fontSize={{ xs: "12px", md: "14px" }}
              color="#004135"
            >
              EMI with Insurance
            </Typography>

            <Typography
              fontWeight={700}
              // fontSize={{ xs: "24px", md: "32px" }}
              fontSize={{ xs: "14px", sm: "18px" }}
              color="#004135"
            >
              {CurrencyConverter(
                (typeof baseEmi === "string" ? toNumber(baseEmi) : baseEmi) +
                  amount,
              )}
              <Typography
                component="span"
                fontWeight={400}
                fontSize={{ xs: "14px", sm: "18px" }}
                color="#1E2525"
                ml={0.25}
              >
                /-
              </Typography>
            </Typography>

            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              gap={0.5}
              sx={{
                backgroundColor: "#FFFFFF",
                px: { xs: 0.75, md: 1 },
                py: { xs: 0.4, md: 0.5 },
                borderRadius: "6px",
                maxWidth: "90%",
              }}
            >
              <Image
                src={IMAGES.trusted}
                alt="trusted"
                width={isBelowMd ? 14 : 18}
                height={isBelowMd ? 14 : 18}
              />

              <Typography
                fontWeight={400}
                fontSize={{ xs: "8px", sm: "10px" }}
                lineHeight={1.2}
                color="#3F3F3F"
              >
                Trusted by 97% of Hero Customers
              </Typography>
            </Stack>
          </Box>
        </Grid>
      </Grid>
      <Stack
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        gap={1}
        mt={{ xs: 1 }}
      >
        <ButtonComponent
          stackWidth={isMobile ? "100%" : "80%"}
          onClick={() => {
            handleContinueWithInsurance();
          }}
        >
          Continue with Insurance
        </ButtonComponent>
        <ButtonComponent
          stackWidth={isMobile ? "100%" : "80%"}
          onClick={() => {
            handleContinueWithoutInsurance();
          }}
          buttonStyle={{
            border: { sm: "none", xs: "1px solid #003128" },
            color: "#003128",
            boxShadow: {
              xs: "2px 2px 2px 2px rgba(0, 0, 0, 0.3)",
              sm: "none",
            },
            backgroundColor: "#fff",
            "&:hover": {
              backgroundColor: WEB_COLORS.lightGrey,
              boxShadow: {
                xs: "2px 2px 2px 2px rgba(0, 0, 0, 0.3)",
                sm: "none",
              },
            },
          }}
        >
          Continue without Insurance
        </ButtonComponent>
      </Stack>
    </Stack>
  );
};

export default LimitedOfferReminder;
